import { DataProvider } from 'react-admin'
import { NotificationConditionalContentDto } from '../../dto/system-notifications/notification-conditional-content.dto'

const fakeContents: NotificationConditionalContentDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeContents, total: fakeContents.length }),
} as DataProvider

export default provider
